import axios from "../components/config/axios";
import key from "../components/config/config";
import * as api from "../components/routes/userroutefront";

let cachedMaps = null;
let loadPromise = null;

export const fetchSportGroupIconMaps = async (force = false) => {
  if (!force && cachedMaps) {
    return cachedMaps;
  }

  if (!force && loadPromise) {
    return loadPromise;
  }

  loadPromise = axios({
    url: key.API_URL + api.getSportGroupIcons,
    method: "get",
  })
    .then((resp) => {
      const result = resp?.data?.result || {};
      cachedMaps = {
        groups: result.groups || {},
        titles: result.titles || {},
      };
      return cachedMaps;
    })
    .catch(() => {
      cachedMaps = { groups: {}, titles: {} };
      return cachedMaps;
    })
    .finally(() => {
      loadPromise = null;
    });

  return loadPromise;
};

export const resolveSportIconUrl = (sportName, maps) => {
  const name = String(sportName ?? "").trim();
  if (!name || !maps) return null;
  return maps.titles?.[name] || maps.groups?.[name] || null;
};

export const clearSportGroupIconCache = () => {
  cachedMaps = null;
  loadPromise = null;
};
